<template>
  <div class="fixed flexCenter" v-if="show">
    <div class="fixedBoxWrap">
      <div class="fixedBox">
        <div class="boxTit">申请签约物资</div>

        <div class="boxCode">
          <img src="../assets/img/wlQR.png" alt="" />
        </div>

        <div class="boxTips">请打开微信扫码申请签约物资</div>

        <div class="boxLogo">良盟|良信合作伙伴联盟</div>
      </div>

      <img
        src="@/assets/images/close.png"
        class="close"
        alt=""
        @click="show = false"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    openShow() {
      this.show = true;
    },
  },
};
</script>

<style lang="less" scoped>
.fixed {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

.fixedBox {
  width: 315px;
  height: 292px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;
}

.boxTit {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #2c3041;
  line-height: 25px;
}

.boxCode {
  margin: 19px 0 23px;
  width: 128px;
  height: 128px;
  background: #f3f6f9;
  border-radius: 8px;
  padding: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}

.boxTips {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #717888;
  line-height: 22px;
  margin-bottom: 23px;
}

.boxLogo {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #abb0c0;
  line-height: 20px;
  text-align: center;
}

.close {
  cursor: pointer;
  width: 34px;
  height: 34px;
  margin-top: 18px;
}

.fixedBoxWrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
